import { InjectedIntl } from 'react-intl';

import { PerformanceValue } from '../generated/graphql';

function formatPerformanceValue(intl: InjectedIntl, { value, type, currency }: PerformanceValue): string {
  switch (type) {
    case 'percentage':
      return intl.formatNumber(value, { style: 'percent', minimumFractionDigits: 2 });
    case 'currency':
      return intl.formatNumber(value, {
        style: 'currency',
        maximumFractionDigits: 2,
        currency: currency!,
        currencyDisplay: 'symbol',
      });
    case 'decimal':
      return intl.formatNumber(value, { style: 'decimal', maximumFractionDigits: 2 });
  }
}

export default formatPerformanceValue;
